"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloydContinuum = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const constants_1 = require("../../constants");
class FloydContinuum extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.FLOYD_CONTINUUM,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 4,
            metadata: {
                cardNumber: '??',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Gain 3 M€ for each completed terraforming parameter.', (eb) => {
                        eb.empty().startAction.megacredits(3).slash().oceans(1, Size_1.Size.SMALL).oxygen(1, Size_1.Size.SMALL).temperature(1, Size_1.Size.SMALL).asterix();
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        let amount = 0;
        if (game.getTemperature() === constants_1.MAX_TEMPERATURE)
            amount += 3;
        if (game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL)
            amount += 3;
        if (game.board.getOceansOnBoard() === constants_1.MAX_OCEAN_TILES)
            amount += 3;
        const requiresVenus = game.gameOptions.venusNextExtension && (game.gameOptions.requiresVenusTrackCompletion || (game.isSoloMode() && !game.gameOptions.soloTR));
        if (requiresVenus && game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE)
            amount += 3;
        player.addResource(Resources_1.Resources.MEGACREDITS, amount, { log: true });
        return undefined;
    }
}
exports.FloydContinuum = FloydContinuum;
//# sourceMappingURL=FloydContinuum.js.map